/**
 * @file actions/Trending/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

// For trending call params
export const NUM_TRENDING_STORIES = 5;
